import React from "react";
import 'stylesheets/comman/button.scss';

const Button = props => {

    const {isDisabled=false}=props
    return (
        <div className={props.grouClass}>
            <button type="submit" className={`btn btn__${props.type}`} onClick={props.click} disabled={isDisabled} style={props.style}>
                <span>{props.value}</span>
            </button>
        </div>
    )
}
export default Button;